import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getRequest} from "../../../../../api";

export const getDifficulty = createAsyncThunk('step1/getDifficulty', async() => {
    try{
        const {data} = await getRequest("/motion/difficulty");
        return data
    }
    catch(err){
        console.log(err)
    }
})

export const getTypes = createAsyncThunk('step1/getTypes', async() => {
    try{
        const {data} = await getRequest("/motion/type");
        return data
    }
    catch(err){
        console.log(err)
    }
})

const step1Slice = createSlice({
    name: 'step1',
    initialState: {
        difficulty: [],
        types: [],
    },
    reducers: {},
    extraReducers(builder){
        builder
            .addCase(getDifficulty.fulfilled, (state, action) => {
                state.difficulty = action.payload
            });
        builder
            .addCase(getTypes.fulfilled, (state, action) => {
                state.types = action.payload
            })
    }
})

export const selectDifficulty = state => state.step1.difficulty
export const selectTypes = state => state.step1.types

export default step1Slice.reducer